import React from "react";

function NoScreen(){
    return(
        <div className='Main'>
            <h1>404 Not Found</h1>
        </div>
    )
}



export default NoScreen;
